// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Article__content-dffe1d {
  padding: 0 16px;
  margin-top: 16px;
}

.Article__title-f4d5a2 {
  font: var(--font-title-9);
  color: var(--base-110);
  letter-spacing: var(--font-spacing-title-9);
}

.Article__title-f4d5a2:hover,
.Article__title-f4d5a2:active {
  color: var(--base-90);
}

@supports (display: block) {
  .Article__title-f4d5a2:focus-visible {
    color: var(--base-90);
  }
}
.Article__text-d04d4d {
  font: var(--font-body-4);
  color: var(--base-110);
  letter-spacing: var(--font-spacing-body-4);
  margin-top: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: 72px;
}

.Article__text-d04d4d a {
  pointer-events: none;
  color: currentColor;
  text-decoration: inherit;
  cursor: text;
}

.Article__button-a0f419 {
  width: 100%;
  height: 40px;
  margin-top: 12px;
  margin-bottom: 4px;
  font: var(--font-body-3);
  letter-spacing: var(--font-spacing-body-3);
  color: var(--chat-bubble-primary) !important;
  background-color: var(--chat-bubble-primary-soft) !important;
}

.Article__clickable-dd6faa {
  max-width: 100%;
  cursor: pointer;
  text-align: left;
}

.Article__preview-ff29c6 {
  min-width: 100%;
  background-color: var(--base-30);
}

.Article__preview-ff29c6.Article__my-preview-a70588 {
  background-color: var(--addition-190);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Article/styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,sBAAA;EACA,2CAAA;AACF;;AAEA;;EAEE,qBAAA;AACF;;AAEA;EACE;IACE,qBAAA;EACF;AACF;AAEA;EACE,wBAAA;EACA,sBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,0CAAA;EACA,4CAAA;EACA,4DAAA;AAAF;;AAGA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gCAAA;AAAF;;AAGA;EACE,qCAAA;AAAF","sourcesContent":[".content {\n  padding: 0 16px;\n  margin-top: 16px;\n}\n\n.title {\n  font: var(--font-title-9);\n  color: var(--base-110);\n  letter-spacing: var(--font-spacing-title-9);\n}\n\n.title:hover,\n.title:active {\n  color: var(--base-90);\n}\n\n@supports (display: block) {\n  .title:focus-visible {\n    color: var(--base-90);\n  }\n}\n\n.text {\n  font: var(--font-body-4);\n  color: var(--base-110);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-top: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  max-height: 72px;\n}\n\n.text a {\n  pointer-events: none;\n  color: currentColor;\n  text-decoration: inherit;\n  cursor: text;\n}\n\n.button {\n  width: 100%;\n  height: 40px;\n  margin-top: 12px;\n  margin-bottom: 4px;\n  font: var(--font-body-3);\n  letter-spacing: var(--font-spacing-body-3);\n  color: var(--chat-bubble-primary) !important;\n  background-color: var(--chat-bubble-primary-soft) !important;\n}\n\n.clickable {\n  max-width: 100%;\n  cursor: pointer;\n  text-align: left;\n}\n\n.preview {\n  min-width: 100%;\n  background-color: var(--base-30);\n}\n\n.preview.my-preview {\n  background-color: var(--addition-190);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Article__content-dffe1d`,
	"title": `Article__title-f4d5a2`,
	"text": `Article__text-d04d4d`,
	"button": `Article__button-a0f419`,
	"clickable": `Article__clickable-dd6faa`,
	"preview": `Article__preview-ff29c6`,
	"my-preview": `Article__my-preview-a70588`,
	"myPreview": `Article__my-preview-a70588`
};
module.exports = ___CSS_LOADER_EXPORT___;
